import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {
  authWithRedirectGuard,
  tenantEnrichmentGuard,
  authorizationWithFallbackGuard,
  featureFlagsLoadedGuard,
} from '@core/guard';
import { RightEnum } from '@core/models/rights.model';

const routes: Routes = [
  {
    path: 'dashboard',
    loadChildren: () => import('./dashboard/dashboard.module').then((m) => m.DashboardModule),
    canActivate: [tenantEnrichmentGuard, authWithRedirectGuard, featureFlagsLoadedGuard, authorizationWithFallbackGuard],
    data: { hasHeader: true, requiredRights: RightEnum.ContreMarque },
  },
  {
    path: 'sales',
    loadChildren: () => import('./sales/sales.module').then((m) => m.SalesModule),
    canActivate: [tenantEnrichmentGuard, authWithRedirectGuard, featureFlagsLoadedGuard, authorizationWithFallbackGuard],
    data: { hasHeader: true, requiredRights: RightEnum.SaleAccess },
  },
  {
    path: 'orders',
    loadChildren: () => import('./orders/orders.module').then((m) => m.OrdersModule),
    canActivate: [tenantEnrichmentGuard, authWithRedirectGuard, featureFlagsLoadedGuard, authorizationWithFallbackGuard],
    data: { hasHeader: true, requiredRights: RightEnum.OrderAccess },
  },
  {
    path: 'customers',
    loadChildren: () => import('./customers/customers.module').then((m) => m.CustomersModule),
    canActivate: [tenantEnrichmentGuard, authWithRedirectGuard, featureFlagsLoadedGuard, authorizationWithFallbackGuard],
    data: { hasHeader: true, requiredRights: RightEnum.CustomerAccess },
  },
  {
    path: 'auth',
    loadChildren: () => import('./core/core.module').then((m) => m.CoreModule),
    data: { hasHeader: false },
  },
  {
    path: 'me',
    loadChildren: () => import('./users/users.module').then((m) => m.UsersModule),
    canActivate: [tenantEnrichmentGuard, authWithRedirectGuard, featureFlagsLoadedGuard],
    data: { hasHeader: true },
  },
  {
    path: 'reports',
    loadChildren: () => import('./reports/reports.module').then((m) => m.ReportsModule),
    canActivate: [tenantEnrichmentGuard, authWithRedirectGuard, featureFlagsLoadedGuard, authorizationWithFallbackGuard],
    data: { hasHeader: true, requiredRights: RightEnum.ReportEditAccess },
  },
  {
    path: 'settings',
    loadChildren: () => import('./settings/settings.module').then((m) => m.SettingsModule),
    canActivate: [tenantEnrichmentGuard, authWithRedirectGuard, featureFlagsLoadedGuard],
    data: { hasHeader: true, requiredRights: RightEnum.ParametersAccess },
  },
  {
    path: 'catalog',
    loadChildren: () => import('./catalog/catalog.module').then((m) => m.CatalogModule),
    canActivate: [tenantEnrichmentGuard, authWithRedirectGuard, featureFlagsLoadedGuard],
    data: { hasHeader: true },
  },
  {
    path: 'price-list',
    loadChildren: () => import('./price-list/price-list.module').then((m) => m.PriceListModule),
    canActivate: [tenantEnrichmentGuard, authWithRedirectGuard, featureFlagsLoadedGuard],
    data: { hasHeader: true, fullscreen: true },
  },
  {
    path: 'subscription-management',
    loadChildren: () =>
      import('./subscription-management/subscription-management.module').then(
        (m) => m.SubscriptionManagementModule,
      ),
    canActivate: [tenantEnrichmentGuard, authWithRedirectGuard, featureFlagsLoadedGuard, authorizationWithFallbackGuard],
    data: { hasHeader: true, requiredRights: RightEnum.SubscriptionManagementAccess },
  },
  {
    path: '',
    redirectTo: 'dashboard',
    pathMatch: 'full',
  },
  {
    path: '**',
    redirectTo: 'dashboard',
    pathMatch: 'full',
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
